<template>
  <app-popup :active.sync="isActive" title="Прикрепление документа" class="apartment-add-document-popup" width="320px">
    <div class="apartment-add-document-popup__row">
      <vs-upload
              action="#"
              :limit="1"
              ref="uploader"
              :show-upload-button="false"
              text="Добавить документ"
              @change="changeFile"
              @on-delete="deleteFile"
              class="w-auto mx-auto"
              :class="{'error': fileError}"
      />
    </div>
    <div class="apartment-add-document-popup__row">
      <app-switch label="Показывать в личном кабинете" size="small" v-model="showToUser"/>
    </div>
    <div class="apartment-add-document-popup__button-row">
      <app-button color="success" type="border" @click="attachDocument">Прикрепить</app-button>
    </div>
  </app-popup>
</template>

<script>
  export default {
    name: "AddDocumentPopup",
    props: {
      type: String,
      appartmentId: {},
      buildingsId: {}
    },
    data() {
      return {
        isActive: false,
        file: null,
        fileError: false,
        showToUser: false
      }
    },
    methods: {
      resetData() {
        this.file = null;
        this.fileError = false;
        this.showToUser = false;
      },
      open() {
        this.isActive = true;
      },
      changeFile(event, files) {
        this.file = files[files.length - 1];
        this.fileError = false;
      },
      deleteFile() {
        this.file = null;
      },
      async attachDocument() {
        if (this.file === null) {
          this.fileError = true;
          return false;
        }

        try {
          let body = {
            file: this.file,
            visible_by_owner: this.showToUser === true ? 1 : 0,
            buildings_id: this.buildingsId
          };

          if(this.type === "apartment"){
            body.to_apartment = this.appartmentId;
          }
          else{
            body.to_buildings = this.buildingsId;
          }

          let bodyFormData = new FormData();

          for (let key in body) {
            if (body.hasOwnProperty(key)) {
              if (Array.isArray(body[key])) {
                for (let i = 0; i < body[key].length; i++) {
                  bodyFormData.append(`${key}[${i}]`, body[key][i]);
                }
              } else {
                bodyFormData.append(key, body[key])
              }
            }
          }

          let {data: response} = await this.$http.post('documents/attach', bodyFormData, {
            headers: {
              'Content-Type': 'multipart/form-data;'
            }
          });
          this.$emit("updated");
          this.isActive = false;
        } catch (e) {
          if (e.response) {
            if (e.response.status === 403) {
              this.$vs.notify({color: 'danger', title: 'Ошибка доступа', text: 'Недостаточно прав'});
            } else
              this.$vs.notify({color: 'danger', title: 'Ошибка сервера', text: 'Повторите позже'});
          } else {
            this.$vs.notify({color: 'danger', title: 'Произошла ошибка', text: 'Неизвестная ошибка'});
          }
        }
      }
    }
  }
</script>

<style lang="scss">
  .apartment-add-document-popup {

    &__row {
      margin-bottom: 15px;
    }

    &__button-row {
      text-align: center;

      .app-button {
        display: block;
        width: 100%;
      }
    }

    .con-img-upload {
      margin: 0;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;

      .img-upload {
        margin: 0;
        border: 1px solid rgba(0, 0, 0, .1);
        box-shadow: none;

        &.removeItem {
          border: none;
        }
      }
    }

    .con-upload.error {
      .con-input-upload {
        border-color: rgba(var(--app-danger), 1);
        color: rgba(var(--app-danger), 1);
      }
    }

    .con-input-upload {
      margin: 0;
      background: transparent;
    }

  }
</style>
